'use client';

import { useState } from 'react';

import { JOB_CATEGORIES } from '../constants/jobCategories';
import { jobPositionsBySegment } from '../constants/jobPositionData';
import Image from 'next/image';

import { CategoryTabs } from './CategoryTabs';
import { JobList } from './JobList';
import CvButtonJob from './CvButtonJob';

export default function JobPositions() {
  const [activeCategory, setActiveCategory] = useState(JOB_CATEGORIES[0].id);
  const [activeIndex, setActiveIndex] = useState(0);

  // タブごとのデータ配列を使用
  const currentPositions = jobPositionsBySegment[activeCategory] || [];

  return (
    <section>
      <div className="bg-[#F7F7F7] pb-[10px] pt-[50px] md:pb-[20px] md:pt-[50px]">
        <div className="container mx-auto px-4">
          <div className="mb-[40px] md:mb-[40px]">
            <div className="flex flex-col items-center">
              <h2 className="text-[28px] font-semibold leading-[42px] tracking-wide text-[#242424] md:text-[32px] md:leading-[48px]">
                ご紹介企業例
              </h2>
              <p className="text-base font-semibold leading-normal text-[#d70c18] md:text-lg md:leading-[27px]">
                POSITIONS
              </p>
            </div>
          </div>
          <CategoryTabs
            activeCategory={activeCategory}
            onCategoryChange={category => {
              setActiveCategory(category);
              setActiveIndex(0); // カテゴリ変更時にインデックスをリセット
            }}
          />
        </div>
      </div>
      <div className="relative pb-[50px] pt-[70px] md:pb-[50px] md:pt-[70px]">
        <Image
          src="/static/images/service-page/img_positions_background.webp"
          alt="Background"
          fill
          priority
          className="z-[-1] object-cover"
          sizes="100vw"
          quality={85}
        />
        <div className="relative px-[10px] md:px-[40px]">
          <JobList
            positions={currentPositions}
            activeIndex={activeIndex}
            onSlideChange={setActiveIndex}
          />
        </div>
        <div className="mt-[30px] flex justify-center md:mt-[30px]">
          <div className="w-full text-center">
            <CvButtonJob />
          </div>
        </div>
      </div>
    </section>
  );
}
